import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mt-5" }
const _hoisted_2 = ["onScrollPassive"]
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-center my-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showLeft)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          icon: "",
          onClick: _ctx.scrollLeft,
          class: "position-fixed scroll-icons"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("mdi-chevron-left")
              ])),
              _: 1,
              __: [2]
            })
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref: "scrollWrapper",
      class: "d-flex overflow-x-auto flex-nowrap w-100 kanban-scroll",
      onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
    }, [
      _createVNode(_component_draggable, {
        modelValue: _ctx.columns,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.columns) = $event)),
        group: "columns",
        "item-key": "id",
        tag: "div",
        class: "d-flex kanban-draggable",
        disabled: true
      }, {
        item: _withCtx(({ element: column }) => [
          _createVNode(_component_v_card, {
            class: "mr-2",
            width: "300",
            style: {"background":"transparent"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "status-title" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(column.name), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_v_divider),
              _createElementVNode("div", {
                class: "kanban-tasks",
                ref: "taskWrappers",
                onScrollPassive: ($event: any) => (_ctx.onColumnScroll(column, $event))
              }, [
                _createVNode(_component_draggable, {
                  modelValue: column.tasks,
                  "onUpdate:modelValue": ($event: any) => ((column.tasks) = $event),
                  group: "tasks",
                  "item-key": "id",
                  tag: "div",
                  onEnd: _ctx.handleTaskMoved,
                  animation: 200,
                  "ghost-class": 'ghost'
                }, {
                  item: _withCtx(({ element: task }) => [
                    _createVNode(_component_v_card, {
                      class: "mx-1 my-2 px-3 py-2",
                      onClick: ($event: any) => (_ctx.$emit('viewItem', task.id))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_subtitle, { class: "px-0" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(task.opportunity_name), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_card_subtitle, {
                          class: "text-caption px-0 mb-1",
                          style: {"transform":"scale(0.8) translateX(-30px) translateY(3px)"}
                        }, {
                          default: _withCtx(() => [
                            (task?.subject?.type=='clients')
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 0,
                                  size: "x-small",
                                  class: "mr-1"
                                }, {
                                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                                    _createTextVNode("mdi-office-building-outline")
                                  ])),
                                  _: 1,
                                  __: [3]
                                }))
                              : _createCommentVNode("", true),
                            (task?.subject?.type=='leads')
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 1,
                                  size: "x-small",
                                  class: "mr-1"
                                }, {
                                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                                    _createTextVNode("mdi-account-outline")
                                  ])),
                                  _: 1,
                                  __: [4]
                                }))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(task?.subject?.attributes?.legal_name || task?.subject?.attributes?.commercial_name || task?.subject?.attributes?.name), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_chip, _mergeProps(_ctx.props, {
                          link: "",
                          pill: "",
                          size: "x-small"
                        }), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_avatar, {
                              class: "pa-1",
                              start: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_img, {
                                  style: {"border-radius":"50%!important"},
                                  src: "https://ionicframework.com/docs/img/demos/avatar.svg"
                                })
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" " + _toDisplayString(task?.user?.name + (task?.user?.last_name ? ' ' + task?.user?.last_name : '')), 1)
                          ]),
                          _: 2
                        }, 1040),
                        _createVNode(_component_v_card_subtitle, { class: "text-caption px-0" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$toCurrency(task.value)), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_card_subtitle, {
                          style: {"transform":"scale(0.8) translateX(-30px)"},
                          class: "text-caption px-0"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(task.date), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_progress_circular, {
                          color: "primary",
                          "model-value": task.forecast_percentage*1,
                          rotate: 360,
                          size: 25,
                          width: 2,
                          style: {"font-size":"8px","position":"absolute","bottom":"10px","right":"10px"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(Math.ceil(task?.forecast_percentage)) + "%", 1)
                          ]),
                          _: 2
                        }, 1032, ["model-value"])
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "onEnd"]),
                (column.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_v_progress_circular, {
                        indeterminate: "",
                        size: "24"
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], 40, _hoisted_2)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 544),
    (_ctx.showRight)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 1,
          icon: "",
          onClick: _ctx.scrollRight,
          class: "position-fixed scroll-icon-right scroll-icons"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("mdi-chevron-right")
              ])),
              _: 1,
              __: [5]
            })
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}